const userdietorder = {
  getlist: 'userdietorderDetail/get-list',
  getlistInUserDietOrder: 'userdietorder/getlist',
  changestatus: 'userdietorder/change-status',
  confirmpay: 'userdietorder/confirm-pay',
  setByAdmin : '/UserDietOrderDetail/set-byadmin',
  verifyOrder :'UserDietOrderDetail/verify-order',
  settleCash:'UserDietOrderDetail/settle-cash',
  changeDietTypeByCash: 'UserDietOrderDetail/change-diettype-bycash',
  changeDietType: 'UserDietOrderDetail/change-diettype',
  setActivation: 'UserDietOrderDetail/set-activation',
  changeExpierTime: 'UserDietOrderDetail/change-expiertime',
  returnMoney: 'UserDietOrderDetail/return-money',
  transferOrder: 'UserDietOrderDetail/transfer-order',
  ActiveCanDiet: 'UserDietOrderDetail/active-candiet',
  CafebazarVerify: 'Cafebazar/verify',
  ZarinpalVerify:'Zarinpal/verify',
  ZarinpalVerifyDirectPay:'Zarinpal/verify/directPay',
  CafeBazarExport:'Cafebazar/excel',
  get:'UserDietOrderDetail/get',
  confirmOrderThatNeedConfirm:'UserDietOrderDetail/needConfirmed/setstatus',
}
export default userdietorder
